import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../../common';
import { Alert } from 'flowbite-react';
import { validateCustomerForm } from '../../../modules/customers/customers';
import { CustomerT } from '../../../types';
import { formatNumber } from '../../../utils';
import PhoneInput from 'react-phone-number-input';
import { InputComponent } from '../../core/Forms';
import { clearFieldError, handleErrors } from '../../../utils/handleErrors';
import toast from 'react-hot-toast';
import LocationSelector from '../../common/Address';
import { ICustomer } from '../../../@types';
import 'react-phone-number-input/style.css';

interface CreateFormProps {
  show: boolean;
  onSubmit: any;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onClose?: () => void;
  buttontitle: string;
  isLoading: boolean;
  customer?: CustomerT;
  errorMessage?: string;
  backendErrorMessage?: string;
  setIsLoadingPrompt?: any;
  setFormData: React.Dispatch<React.SetStateAction<ICustomer>>;
}

interface ValidationErrors {
  firstName: string;
  lastName: string;
  phone: string;
}

const CreateForm: React.FC<CreateFormProps> = (props) => {
  const { customer, onSubmit, isLoading, backendErrorMessage, setIsLoadingPrompt } = props;
  React.useState('');
  const [, setErrorMessage] = React.useState('');
  const [, setIsOpen] = React.useState(props.show);
  const [value, setValue] = useState('');
  // const [backendErrorMessageHandler, setBackendErrorMessage] = React.useState('');
  const [backendErrorMessageHandler, setBackendErrorMessage] = React.useState(backendErrorMessage || '');

  const [firstName, setFirstName] = React.useState(customer?.firstName);
  const [lastName, setlastName] = React.useState(customer?.lastName);
  const [email, setEmail] = React.useState(customer?.email);
  const [phone, setPhone] = React.useState(customer?.phone);
  const [address, setAddress] = React.useState(customer?.address);
  const [state, setState] = React.useState(customer?.state || '');
  const [city, setCity] = React.useState(customer?.city || '');

  const [businessName, setBusinessName] = React.useState(customer?.businessName);
  const errorFieldRef = useRef<HTMLInputElement | null>(null);
 const [placeholder] = useState('+234 900 000 0000');
  const [firstErrorField, setFirstErrorField] = useState<string | null>(null);
  const [showAddressFields, setShowAddressFields] = useState(false);
  const inputRefs: Record<string, React.RefObject<HTMLInputElement>> = {
    firstName: useRef(null),
    lastName: useRef(null),
    phone: useRef(null),
  };

  const errorRefs: Record<string, React.RefObject<HTMLDivElement>> = {
    firstName: useRef(null),
    lastName: useRef(null),
    phone: useRef(null),
  };

  const [validationResults, setValidationResults] = useState({
    firstName: '',
    lastName: '',
    phone: '',
  });

  function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    setBackendErrorMessage(backendErrorMessage as string);
  }, []);

  React.useEffect(() => {
    setBackendErrorMessage(backendErrorMessage || '');
  }, [backendErrorMessage]);
  

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    switch (name) {
      case 'firstName':
        setFirstName(capitalizeFirstLetter(value));
        break;
      case 'lastName':
        setlastName(capitalizeFirstLetter(value));
        break;
      case 'email':
        setEmail(value.toLowerCase());
        break;
      case 'phone':
        setPhone((prevPhone) => value);
        break;
      case 'address':
        setAddress((prevAddress) => value);
        break;
      case 'city':
        setCity((prevCity) => value);
        break;
      case 'state':
        setState((prevState) => value);
        break;
      case 'businessName':
        setBusinessName((prevBusinessName) => value);
        break;
      default:
        break;
    }
    clearFieldError(name, validationResults, setValidationResults);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { hasErrors, errors } = validateCustomerForm({ firstName, lastName, phone });

    setValidationResults(errors);


    if (firstErrorField) {
      const errorContainer = inputRefs[firstErrorField];

      if (errorContainer && errorContainer.current) {
        errorContainer.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    if (!hasErrors) {
      const newCustomer = { firstName, lastName, phone, address, email };

      try {
        const ifSubmitted = await onSubmit(newCustomer);
        if (ifSubmitted) {
          setIsLoadingPrompt(true);
        }
      } catch (error: any) {
        if (error.response && error.response.data && error.response.data.message) {
          if (error.response.status === 409 && error.response.data.message === 'Phone number already exists') {
            return 'Phone number already exists';
          } else {
            return error.response.data.message; 
          }
        } else {
          return 'An error occurred'; 
        }
      }
    }
    
    return null; 
  };
 

  const handlePhoneNumberChange = (value: string) => {
    const formattedPhone = formatNumber(value);
    setValue(value);
    setPhone(formattedPhone);
  };

  React.useEffect(() => {
    setIsOpen(props.show);
  }, []);

  React.useEffect(() => {
    setPhone(customer?.phone || '');
  }, [customer]);



  useEffect(() => {
    let intervalId: any;
    if (backendErrorMessageHandler) {
      intervalId = setTimeout(() => {
        setBackendErrorMessage('');
      }, 7000);
    }

    return () => {
      clearTimeout(intervalId);
    };
  }, [backendErrorMessageHandler]);

  const handleLocationChange = (selectedState: string, cities: string | any[]) => {
    setState(selectedState);
    setCity(cities.length > 0 ? cities[0] : '');

    props.setFormData((prevData) => ({
      ...prevData,
      state: selectedState,
      city: cities.length > 0 ? cities[0] : '',
    }));
  };

  const handlePhoneNumberKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.currentTarget.value.length >= 17) {
      event.preventDefault();
    }
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowAddressFields(e.target.checked);
  };

  return (
    <div className="h-[500vh] text-center 360:text-center ">
      {' '}
      <form className="" action="" onSubmit={handleSubmit}>
        {backendErrorMessageHandler && (
          <Alert className="text-center" color="failure">
            {backendErrorMessageHandler}
          </Alert>
        )}

          <div id="input-container" className=" xl:px-[5px] m-[]   " ref={errorFieldRef}>
            <label
              htmlFor=" First Name"
              className="block text-[13px] text-black text-left"
              style={{ whiteSpace: 'nowrap' }}
            >
              First Name<span className="text-red-500 ml-[14.7em] md:ml-[22.5em] xl:ml-[23em] biglg:ml-[22.3em] lg:ml-[22em]">**Required</span>
            </label>
            <InputComponent
              placeholder="First Name"
              name="firstName"
              type="text"
              value={firstName}
              handleChange={handleInputChange}
              error={validationResults.firstName}
              className="rounded-[5px] xl:w-[434px] w-[320px] md:w-[420px] lg:ml-[-0.6em] "
              ref={inputRefs.firstName}
            />
          </div>
          <div className=" mt-[16px] lg:mt-[37px] ">
            <label
              htmlFor="Last Name"
              className="block  text-[13px] xl:text-black text-left"
              style={{ whiteSpace: 'nowrap' }}
            >
              Last Name<span className="text-red-500 ml-[14.7em] md:ml-[22.5em] xl:ml-[23em] biglg:ml-[22.3em] lg:ml-[22em]">**Required</span>
            </label>
            <InputComponent
              placeholder="Last Name"
              name="lastName"
              type="text"
              value={lastName}
              handleChange={handleInputChange}
              error={validationResults.lastName}
              className="rounded-[5px] xl:w-[434px] w-[320px] md:w-[420px] lg:ml-[-0.6em] "
              ref={inputRefs.lastName}
            />
          </div>
          <div className="mt-[16px]  lg:mt-[37px]">
          <label
            htmlFor="Phone Number"
            className="block font-sm font-weight-[400] text-[13px] text-black text-left "
            style={{ whiteSpace: 'nowrap' }}
          >
            Phone Number<span className="text-red-500 ml-[12.7em] md:ml-[20.3em] xl:ml-[21.5em] biglg:ml-[20.5em] lg:ml-[20em]">**Required</span>
          </label>
           <PhoneInput
                  placeholder={placeholder}
                  limitMaxLength={true}
                  defaultCountry="NG"
                  value={phone}
                  onChange={handlePhoneNumberChange}
                  className="border rounded-[5px] placeholder:text-[13.25px] h-[48px] xl:w-[434px] w-[320px] md:w-[420px] "
                  inputClassName="react-phone-number-input__input"
                  onKeyDown={handlePhoneNumberKeyDown}
                  maxLength={17}
                  countries={['NG']} 
                />
             
        </div>
        <div className=" mt-[16px] lg:mt-[37px]">
          <label htmlFor="Email" className="block text-[13px] text-black text-left ">
            Email
          </label>
          <InputComponent
            name="email"
            placeholder="Email Address"
            type="text"
            value={email}
            handleChange={handleInputChange}
            className="rounded-[5px] xl:w-[434px] w-[320px] md:w-[420px] lg:ml-[-0.6em]"
          />
        </div>
        <div className="flex items-center mt-[2em]">
          <input
            type="checkbox"
           id="toggleAddressFields"
            checked={showAddressFields}
            onChange={handleCheckboxChange}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
          <label htmlFor="link-checkbox" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
          Click here to fill in more details    .
          </label>
        </div>
        {showAddressFields && (
          <div>
        <div className="mt-[16px]  lg:mt-[37px]">
          <label htmlFor="BusinessName" className="block text-[13px] text-black text-left ">
            Business Name
          </label>
          <InputComponent
            name="businessName"
            placeholder="Business Name"
            type="text"
            value={businessName}
            handleChange={handleInputChange}
            className="rounded-[5px] xl:w-[434px] w-[320px] md:w-[420px] lg:ml-[-0.6em]"
          />
        </div>
     
        <div className=" mt-[16px]  lg:mt-[37px]">
          <label htmlFor="Address" className="block text-[13px] text-black text-left">
            Address
          </label>
          <InputComponent
            placeholder="Billing Address"
            name="address"
            type="text"
            value={address}
            handleChange={handleInputChange}
            className="rounded-[5px] xl:w-[434px] w-[320px] md:w-[420px] xl:mt-[-0.1em] lg:ml-[-0.6em]"
          />
        </div>
        <div className="w-[320px] mt-[1em]  md:w-[420px] xl:w-[434px] lg:mt-[1em] xl:mt-[-2.5em] ">
          <LocationSelector
            onLocationChange={handleLocationChange}
            onError={(error: any) => {}}
            selectedState={state}
            selectedCity={city}
          />
        </div>
         </div>
        )}
        <div className="mt-[32px]  flex justify-center xl:mt-[1.5em] w-[215px] lg:ml-[5em] ml-[3em] md:ml-[6em]">
          <Button isLoading={isLoading} text={props.buttontitle} size="full" onClick={onSubmit} />
        </div>
      </form>
    </div>
  );
};

export default CreateForm;




